module.exports = __webpack_public_path__ + "img/lekarne_kartica.0e880fdf.png";